<template>
  <label class="search-bar">
    <former-input
      ref="input"
      class="search-bar-input"
      :field="field"
      :value="value"
      :autofocus="autofocus"
      focusless
      @input="input"
    />
  </label>
</template>

<script>
  import { input } from '@/_CRUDL/helpers/form/fields';

  import FormerInput from '@/components/Former/Field/Input.vue';

  export default {
    name: 'SearchBar',
    components: {
      FormerInput,
    },
    props: {
      id: {
        type: String,
        default: null,
      },
      value: {
        type: String,
        default: '',
      },
      autofocus: {
        type: Boolean,
        default: false,
      },
      options: {
        type: Object,
        default() {
          return {};
        },
      },
      placeholder: {
        type: String,
        default: 'Pesquisar...',
      },
    },
    computed: {
      field() {
        return {
          ...input,
          size: 4,
          id: this.id || 'input-search',
          placeholder: this.placeholder,
          ...this.options,
        };
      },
    },
    watch: {
      'field.mask.type': {
        handler() {
          this.$nextTick(this.$refs.input.focus);
        },
      },
    },
    methods: {
      input(value) {
        this.$emit('input', value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .search-bar {
    display: block;
    margin: 0 $gutter;
    position: relative;
  }

  .search-bar-input {
    flex: 1;
  }
</style>
